import script from "./PetSpecies.vue?vue&type=script&setup=true&lang=js"
export * from "./PetSpecies.vue?vue&type=script&setup=true&lang=js"

import "./PetSpecies.vue?vue&type=style&index=0&id=527a8461&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-527a8461"]])

export default __exports__